import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MarketingTile } from '../../../services/graphql.service';
import { Observable } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-landing-marketing',
  templateUrl: './landing-marketing.component.html',
  styleUrls: ['./landing-marketing.component.scss'],
})
export class LandingMarketingComponent implements OnInit {
  @Input() marketingTiles: Observable<MarketingTile[]>;
  isMobile = false;

  primengResponsiveOptions;

  constructor(private _analytics: AnalyticsService) {
    // Config options for "primeng carousel"
    this.primengResponsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    if (window.innerWidth <= 576) {
      this.isMobile = true;
    }
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  @HostBinding('window:resize') onResize(event) {
    if (event.target.innerWidth <= 576) {
      if (!this.isMobile) {
        this.isMobile = true;
      }
    } else {
      if (this.isMobile) {
        this.isMobile = false;
      }
    }
  }
  openLink(link): void {
    this._analytics.logLinkTap('landing_doNotSellInfo');
    window.open(link);
  }
}
